import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTextBold = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.292 5h4.512c1.827 0 3.46 1.336 3.633 3.156A3.5 3.5 0 0 1 11.954 12H7.292zM7.292 12h5.765c1.828 0 3.46 1.336 3.634 3.156A3.5 3.5 0 0 1 13.208 19H7.292z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTextBold);
export default ForwardRef;
